import React from 'react';
import { CheckCircle2, Circle, Sparkles } from 'lucide-react';

/**
 * Barre de complétude du profil boutique fournisseur.
 * Motive le fournisseur à remplir les éléments manquants.
 * Props :
 *  - store : objet boutique (store_logo, store_banner, store_description...)
 *  - productsCount : nombre de produits
 *  - onGoTo : callback(tab) pour naviguer vers l'onglet concerné
 */
const ProfileCompleteness = ({ store = {}, productsCount = 0, onGoTo }) => {
  const criteria = [
    { key: 'logo', label: 'Ajouter un logo', done: !!store.store_logo, tab: 'boutique' },
    { key: 'banner', label: 'Ajouter une bannière', done: !!store.store_banner, tab: 'boutique' },
    { key: 'description', label: 'Rédiger une description', done: !!(store.store_description && store.store_description.trim()), tab: 'boutique' },
    { key: 'products', label: 'Ajouter au moins 5 produits', done: productsCount >= 5, tab: 'products' },
    { key: 'delivery', label: 'Indiquer vos infos de livraison', done: !!(store.delivery_note && store.delivery_note.trim()), tab: 'settings' },
  ];
  const doneCount = criteria.filter(c => c.done).length;
  const percent = Math.round((doneCount / criteria.length) * 100);

  // Si tout est complété, message de félicitation discret
  if (percent === 100) {
    return (
      <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-5 flex items-center gap-3">
        <CheckCircle2 className="w-6 h-6 text-emerald-600 flex-shrink-0" />
        <div>
          <div className="font-medium text-emerald-900">Profil complété à 100%</div>
          <div className="text-sm text-emerald-700">Votre boutique est optimale pour attirer les clients.</div>
        </div>
      </div>
    );
  }

  const nextTodo = criteria.find(c => !c.done);

  return (
    <div className="bg-white border border-[#E8E0D0] rounded-xl p-4 mb-5">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-[#C75B27]" />
          <span className="font-medium text-[#2D2A26]">Complétez votre boutique</span>
        </div>
        <span className="text-sm font-semibold text-[#1F4D3F]">{percent}%</span>
      </div>
      {/* Barre de progression */}
      <div className="h-2 bg-[#F5F1EA] rounded-full overflow-hidden mb-3">
        <div className="h-full bg-gradient-to-r from-[#1F4D3F] to-[#2D6452] transition-all duration-500" style={{ width: `${percent}%` }} />
      </div>
      <p className="text-xs text-[#7A6F5C] mb-3">Une boutique complète inspire confiance et attire plus de clients.</p>
      {/* Liste des critères */}
      <div className="space-y-1.5">
        {criteria.map((c) => (
          <button key={c.key} onClick={() => !c.done && onGoTo && onGoTo(c.tab)}
            disabled={c.done}
            className={`w-full flex items-center gap-2 text-sm text-left ${c.done ? 'text-[#9A8F82]' : 'text-[#2D2A26] hover:text-[#1F4D3F]'}`}>
            {c.done ? <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" /> : <Circle className="w-4 h-4 text-[#C9BFAE] flex-shrink-0" />}
            <span className={c.done ? 'line-through' : ''}>{c.label}</span>
            {!c.done && <span className="ml-auto text-xs text-[#C75B27]">→</span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileCompleteness;
